export default "__VITE_ASSET__Bj6LdX5F__"